import React from "react";
import ReactGA from 'react-ga';
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import App from "./pages/app";

// https://serverless-stack.com/chapters/environments-in-create-react-app.html
const isProd = process.env.REACT_APP_STAGE === 'production';

isProd && ReactGA.initialize('UA-134441849-2');


const Root = ({ store }) => (
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" component={App} />
    </BrowserRouter>
  </Provider>
);

export default Root;
